export default __webpack_public_path__ + "static/media/TreasurersTools.6a179e54.png";